/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mmapsFooter[_ngcontent-%COMP%]{background:#005984;border-radius:0;height:2.625rem;width:100%;position:relative;z-index:9999}.footerText[_ngcontent-%COMP%]{margin:auto;padding-top:.75rem;color:#fff;font-size:.75rem;font-weight:400;height:1.188rem;letter-spacing:.01rem;line-height:1.188rem;text-align:center;width:100%}"];
export { styles as styles };
